import React from 'react'
import { Link } from 'react-router-dom'
import { Image, Grid, GridItem } from '@deal/components'
import PageContent from '#src/components/PageContent'
import { RoryReviewsComponent } from '#src/generated/graphql'
import Reviews from '../Reviews'
import sa from './sa.png'
import ratings from './ratings.png'
import styles from './styles.css'

interface Props {
  departmentId: string
  aboutCurated?: string
}

const Footer: React.SFC<Props> = ({ departmentId, aboutCurated }) => (
  <PageContent className={styles.container}>
    <Grid>
      <GridItem col={2} smCol={4} className={styles.aboutContainer}>
        {aboutCurated && (
          <>
            <div className={styles.aboutTitle}>About Curated</div>
            <div className={styles.aboutBody}>{aboutCurated}</div>
          </>
        )}
        <div className={styles.linksContainer}>
          <Link to="/legal/privacy-policy" className={styles.link}>
            Privacy
          </Link>
          <Link to="/legal/terms-conditions" className={styles.link}>
            Terms & Conditions
          </Link>
        </div>
      </GridItem>
      <GridItem col={2} smCol={4}>
        <RoryReviewsComponent variables={{ departmentId }}>
          {({ data }) => {
            if (data && data.department) {
              return (
                <>
                  <div className={styles.saHeader}>
                    <Image src={sa} className={styles.shopperLogo} size="90px" sizeSm="116px" />

                    <div className={styles.saHeaderSummary}>
                      {data.department.reviewSummary.totalReviews > 0 && (
                        <>
                          <div className={styles.satisfactionContainer}>
                            <div className={styles.ratingContainer}>
                              {data.department.reviewSummary.averageRating && (
                                <div className={styles.rating}>
                                  {Math.round(
                                    (data.department.reviewSummary.averageRating * 100) / 100
                                  ).toFixed(1)}
                                </div>
                              )}
                            </div>
                            <div className={styles.satisfactionText}>
                              {' '}
                              Overall Satisfaction Rating
                            </div>
                          </div>
                          {data.department.reviewSummary.totalReviews > 0 && (
                            <div className={styles.totalRatings}>
                              Based on {data.department.reviewSummary.totalReviews} Ratings
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <Image src={ratings} className={styles.ratingImage} width={97} height={49} />
                  </div>
                  <Reviews
                    reviews={data.department.consumerExpertReviewConnection.edges.map(
                      ({ node }) => node
                    )}
                  />
                </>
              )
            }
            return null
          }}
        </RoryReviewsComponent>
      </GridItem>
    </Grid>
  </PageContent>
)

export default Footer
